import React, { Component } from 'react';
import cx from 'classnames';
import { SHOP_ID, SC_ID } from 'constants/payments';
import tarifSolo from 'assets/images/tarif-solo.svg';
import s from './style';
import tracker from '../../../services/tracker';
import { withTranslation } from 'react-i18next';
import FormTechnicalProblem from 'components/Login/FormTechnicalProblem/FormTechnicalProblem';

class PayForTarif extends Component {
  constructor(props) {
    super(props);

    this.state = {
      showError: !props.url
    };
  }

  pay = () => {
    tracker.sendEvent('Web_Profile_Renew_Subscription');
  }

  showRequestForm = () => {
    this.props.showRequestForm();
  }

  render() {
    const { userId, orderNumber, shopSuccessUrl, shopFailUrl, t, url } = this.props;
    const { showError } = this.state;
    return (
      <div className={s.TarifPay}>
        {showError && <FormTechnicalProblem handleCloseModal={() => this.setState({ showError: false })} />}
        <div className={s.TarifPayHead}>
          {t('components.payments.payForTarif.title')}
          {/* <img src={visaMastercard} alt="Visa, MasterCard" className={s.VisaMAstercard} /> */}
        </div>
        <div className={s.Tarifs}>
          <form
            className={s.TarifSolo}
            onSubmit={this.pay}
          >
            {/* FIXME: put scid, shopId to env */}
            <input name="shopId" value={SHOP_ID} type="hidden" />
            <input name="scid" value={SC_ID} type="hidden" />
            <input name="customerNumber" value={userId} type="hidden" />
            <input name="orderNumber" type="hidden" value={orderNumber} />
            <input name="sum" value="2000.00" type="hidden" />
            <input name="shopSuccessUrl" value={shopSuccessUrl} type="hidden" />
            <input name="shopFailUrl" value={shopFailUrl} type="hidden" />
            <img src={tarifSolo} alt={t('components.payments.payForTarif.tarifImg')} className={s.TarifImage} />
            <div className={s.TarifName}>
              {t('components.payments.payForTarif.name')}
            </div>
            <div className={s.TarifDescrip}>
              {t('components.payments.payForTarif.description')}
            </div>
            <div className={s.TarifPrice}>
              {t('components.payments.payForTarif.price')}
            </div>
            <div className={s.TarifTerm}>
              {t('components.payments.payForTarif.time')}
            </div>
            {url && <a
              href={url}
              target="__blank"
              onClick={this.pay}
              className={cx(s.TarifBuyBtn, 'button-primary', 'button-primary--lg')}
            >
              {t('components.payments.payForTarif.pay')}
            </a>}
            <div
              className={s.TarifText}
              dangerouslySetInnerHTML={{ __html: t('components.payments.payForTarif.text') }}
            />
          </form>
          {/* <div className={s.TarifCompany}>
            <img src={tarifCompany} alt="Подключайся агентством" className={s.TarifImage}/>
            <div className={s.TarifName}>Подключайся агентством</div>
            <div className={s.TarifDescrip}>
              Профиль компании
            </div>
            <div className={s.TarifDescrip}>
              Подборки для клиентов <br/>в&nbsp;вашем фирменном стиле
            </div>
            <div className={s.TarifDescrip}>
              Контроль за сотрудниками
            </div>
            <button className={s.TarifRequestBtn} onClick={this.showRequestForm}>Оставить заявку</button>
          </div>

           */}
        </div>
      </div>
    );
  }
}

export default withTranslation()(PayForTarif);



// WEBPACK FOOTER //
// ./src/components/Payments/PayForTarif/PayForTarif.js